import { FaSpinner } from "react-icons/fa";
import styled, { keyframes } from "styled-components";

export const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f9f9f9;
  border-radius: 8px;
  color: #333;
  width: 100%;
  height: 100%;
`;

export const SpinnerIcon = styled(FaSpinner)`
  font-size: 2.5rem;
  animation: ${spin} 1s linear infinite;
  color: #6e6e6e;
  margin-bottom: 1rem;
`;

export const LoadingText = styled.div`
  font-size: 1rem;
  font-weight: bold;
`;

export const SubText = styled.div`
  font-size: 0.7rem;
  color: #888;
  margin-top: 0.5rem;
`;
